// extracted by mini-css-extract-plugin
var _1 = "ra-fixed-height-slider";
var _2 = "200px";
export { _1 as "fixedHeightSliderCls", _2 as "fixedHeightSliderMinMediaWidth" }
